export function documentHasElements(selector: string, callback: (elements: NodeListOf<Element>) => void): boolean {
    const elements = document.querySelectorAll(selector);
    if (elements.length) {
        callback(elements);
        return true;
    }

    return false;
}

export function queryAndIterateElements(selector: string, callback: (element: HTMLElement, key: number, elemList: NodeListOf<Element>) => void, parentNode?: ParentNode): void {
    const elements = (parentNode || document).querySelectorAll<HTMLElement>(selector);
    elements.forEach(callback);
}

export function iterateElementsWithClassName(className: string, callback: (element: HTMLElement, key: number, elemList: HTMLCollectionOf<Element>) => void, parentElement?: Element): void {
    const elements = (parentElement || document).getElementsByClassName(className);
    // Iterate over the elements
    for (let i = 0; i < elements.length; i++) {
        callback(elements[i] as HTMLElement, i, elements);
    }
}

export function equalizeHeight(selector: string, rootElement?: HTMLElement) {
    const elements = (rootElement ||document).querySelectorAll<HTMLElement>(selector);
    let maxHeight = 0;

    // Reset any previously set heights to avoid conflicts
    elements.forEach(function (element) {
        element.style.height = 'auto';  // Reset height first
    });

    // Calculate the maximum height
    elements.forEach(function (element) {
        const elementHeight = element.offsetHeight;
        if (elementHeight > maxHeight) {
            maxHeight = elementHeight;
        }
    });

    // Set the maximum height to all elements
    elements.forEach(function (element) {
        element.style.height = maxHeight + 'px';
    });
}